module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-sessionLab"
  }, [_c('div', {
    staticClass: "headBox"
  }, [_c('span', {
    staticClass: "headBox-title"
  }, [_vm._v(_vm._s(_vm.Language('客户标签')))]), _vm._v(" "), _c('span', {
    staticClass: "headBox-val"
  }, [_vm._v(_vm._s(_vm.selectedList))])]), _vm._v(" "), _c('div', {
    staticClass: "searchInput"
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.Language('搜索标签')))]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "",
      "options": _vm.optionsList,
      "props": _vm.props,
      "filterable": ""
    },
    on: {
      "change": _vm.handleChangeFn
    },
    model: {
      value: (_vm.selectedLablist),
      callback: function($$v) {
        _vm.selectedLablist = $$v
      },
      expression: "selectedLablist"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cusLabelListBox"
  }, [_c('el-cascader-panel', {
    ref: "myCascader",
    attrs: {
      "options": _vm.optionsList,
      "props": _vm.props
    },
    on: {
      "change": _vm.handleChangeFn
    },
    model: {
      value: (_vm.selectedLablist),
      callback: function($$v) {
        _vm.selectedLablist = $$v
      },
      expression: "selectedLablist"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnList"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleComitFn(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('取 消')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleComitFn(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('确 定')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-63945d1b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/CusLable.vue
// module id = 1334
// module chunks = 5